import { Amplify } from 'aws-amplify';
import { createApp } from 'vue';
import VueGtag from 'vue-gtag-next';

import constants from '@/config/constants';

import App from './App.vue';
import { i18n } from './plugin/i18n';
import router from './router';
import store from './store';
import VueCookies from 'vue3-cookies';
import 'bootstrap/dist/js/bootstrap.bundle.min';

const awsConfig = {
  Auth: {
    identityPoolId: constants.COGNITO_IDPOOL_ID,
    region: constants.COGNITO_REGION,
    userPoolId: constants.COGNITO_USERPOOL_ID,
    userPoolWebClientId: constants.COGNITO_CLIENT_ID
  }
};

Amplify.configure(awsConfig);

createApp(App)
  .use(store)
  .use(router)
  .use(VueCookies, {
    expireTimes: constants.COOKIE_EXPIRE_TIMES,
    secure: process.env.NODE_ENV === 'production' ? true : false
  })
  .use(i18n)
  .use(VueGtag)
  .mount('#app');
